module.exports = __webpack_public_path__ + "img/boton_mult_od.34c8d7c6.svg";